import React from "react";

import Button from "../../button/Button";
import { Remove } from "../../svg/svgImageList";
import useThemeService from "../../../services/theme-service/ThemeService";
import useModal from "../../dialog/useModal";
import WarningBeforeAction from "../../data-components/WarningBeforeAction";
import { TranslationContext } from "../../../services/translation/TranslationService";

interface RemoveButtonProps {
  disabled?: boolean;
  confirmationModalTitleKey: string;
  confirmationModalTitleContext?: TranslationContext;
  confirmationModalSubtitleKey: string;
  confirmationAction: () => void;
}

export default function RemoveButton(props: RemoveButtonProps) {
  const { themeClass } = useThemeService();
  const { toggleModal, isVisible } = useModal();

  const {
    disabled,
    confirmationAction,
    confirmationModalTitleKey,
    confirmationModalTitleContext,
    confirmationModalSubtitleKey,
  } = props;

  const handleConfirmationAction = () => {
    confirmationAction();
    toggleModal();
  };

  return (
    <>
      <Button
        id="remove"
        disabled={disabled}
        onClick={toggleModal}
        icon={{
          svg: Remove,
          textKey: "general.remove",
          textClass: "actions-header-button-label",
          className: themeClass(["icon-remove"]),
        }}
      />
      <WarningBeforeAction
        isVisible={isVisible}
        titleKey={confirmationModalTitleKey}
        titleContext={confirmationModalTitleContext}
        subtitleKey={confirmationModalSubtitleKey}
        buttonOk={{
          id: "remove-ok",
          textKey: "general.remove",
          action: handleConfirmationAction,
        }}
        toggleModal={toggleModal}
      />
    </>
  );
}
